import * as React from "react";
const SvgFiRrFloorLayer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-floor-layer_svg__a)">
      <path
        fill="#062147"
        d="m22.014 5.835-7.42-3.558a5.98 5.98 0 0 0-5.188 0l-7.42 3.558A3.52 3.52 0 0 0 0 8.991v1.162c0 1.338.779 2.577 1.986 3.156l7.412 3.554a6 6 0 0 0 2.594.593c.89 0 1.78-.2 2.609-.6l7.42-3.583A3.52 3.52 0 0 0 24 10.121v-1.13a3.52 3.52 0 0 0-1.986-3.156M10.27 4.081a3.98 3.98 0 0 1 3.459 0l6.957 3.336-8.563 4.107c-.123.074-.246 0-.246 0L3.313 7.418zm-7.42 7.424A1.51 1.51 0 0 1 2 10.152V9.006l9 4.316v1.995a4 4 0 0 1-.736-.257zm18.302-.033-7.42 3.583a4 4 0 0 1-.732.257v-1.99l9-4.316v1.115a1.51 1.51 0 0 1-.848 1.351m2.748 4.33a1 1 0 0 1-.466 1.335l-8.833 4.265a6 6 0 0 1-2.61.601c-.884 0-1.77-.198-2.593-.594L.567 17.176a1 1 0 0 1 .865-1.804l8.83 4.234a3.98 3.98 0 0 0 3.47-.004l8.833-4.265a1 1 0 0 1 1.336.465"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-floor-layer_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFloorLayer;
